<template>
  <div class='wca-panel'>
    <div v-for='(info, i) in solverInfoObjects' :key='i' :class='{solverinfo: !!info, infopanel: true}'>
      <v-container v-if='info'>
        <h1>{{info.solverName}}</h1>
        <v-row>
          <v-col cols='3'>
            <div>{{info.event.numCompetitions}} competitions</div>
            <div>PR Single: {{info.event.single.time}}</div>
            <div v-if='info.event.average.time'>PR Average: {{info.event.average.time}}</div>
            <div v-if='info.event.medals.gold + info.event.medals.silver + info.event.medals.bronze'>{{info.event.medals.gold + info.event.medals.silver + info.event.medals.bronze}} medals</div>
          </v-col>
          <v-col cols='3'>
            <strong>Overall</strong><br/>
            <div>{{info.total.numCompetitions}} total competitions</div>
            <div>{{info.total.numSolves}} total solves</div>
            <div>{{info.total.medals.gold + info.total.medals.silver + info.total.medals.bronze}} total medals</div>
          </v-col>
          <v-col cols='3'>
            <strong>Single</strong><br/>
            <div>WR {{info.event.single.WR}}</div>
            <div>CR {{info.event.single.CR}}</div>
            <div>NR {{info.event.single.NR}}</div>
          </v-col>
          <v-col cols='3' v-if='info.event.average.time'>
            <strong>Average</strong><br/>
            <div>WR {{info.event.average.WR}}</div>
            <div>CR {{info.event.average.CR}}</div>
            <div>NR {{info.event.average.NR}}</div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client'
import AdminService from '@/services/TPC/AdminService'

export default {
  name: 'wca-panel',
  data () {
    return {
      solverWca: ['', ''],
      solverInfoObjects: ['', ''],
    }
  },
  methods: {
    swap (obj) {
      let tmp = obj[0]
      this.$set(obj, 0, obj[1])
      this.$set(obj, 1, tmp)
    }
  },
  async created () {
    this.$store.state.socket = io.connect(this.$backendHost, {
      query: {
        connectionType: 'stream',
      }
    })

    this.$store.state.socket.on('ehlo', async () => {
      //noop
    })

    this.$store.state.socket.on('solver', async (data) => {
      this.solverWca[data.pos] = data.wcaID
      const result = await AdminService.getWcaInfo({
        wcaID: data.wcaID
      })
      if (result.data.success) {
        this.$set(this.solverInfoObjects, data.pos, result.data.solverInfo)
      } else {
        this.$set(this.solverInfoObjects, data.pos, false)
      }
    })
    
    this.$store.state.socket.on('swap', () => {
      this.swap(this.solverWca)
      this.swap(this.solverInfoObjects)
    })
  },
}
</script>

<style scoped>
.solverinfo {
  background: rgba(100, 100, 100, .4);
  color: white;
  font-size: 25px;
  text-align: left;
  padding-left: 30px;
}

.infopanel {
  height: 250px;
}
</style>
